import TurboBridge from '../bridges/turbo.js';

window.turboBridge = TurboBridge;